var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.authGoogle}},[_c('v-icon',[_vm._v("mdi-google")]),_vm._v(" Connect Google")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }